const Diamond = () => <span className="mx-6 inline-block h-2 w-2 rotate-45 bg-coacher-red sm:mx-10" aria-hidden="true" />;

const Marquee = ({ items, className = "" }) => {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap font-display text-sm sm:text-base font-semibold uppercase tracking-[0.25em] text-white/85">
          {item}
          <Diamond />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden bg-coacher-navy-deep py-4 sm:py-5 ${className}`} aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};

export default Marquee;
